var map = {
	"./Base.js": "2fd6",
	"./Business.js": "607b",
	"./Classroom.js": "fd57",
	"./Fund.js": "a8fc",
	"./Goods.js": "5463",
	"./Mall.js": "da4f",
	"./Order.js": "f4c8",
	"./OrganizationalStructure.js": "08a3",
	"./PowerManage.js": "e028",
	"./UserManage.js": "3144"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7191";